import { Alert } from 'antd';
import { Weight } from 'lucide-react';
import { CataloguePanel } from '../../../components/CataloguePanel';
import { useWeightBands } from '../hooks/use-weight-bands';
import { buildWeightBandColumns } from './build-weight-band-columns';
import { WeightBandFormDrawer } from './WeightBandFormDrawer';

/** The bands loose-cargo rate lines are priced by (gitaumoses4/chukua#23, #355). */
export function WeightBandsPanel() {
  const { state, saveError, saving, resetSaveError, create, update, deactivate, reactivate } = useWeightBands();
  return (
    <CataloguePanel
      noun="weight band"
      plural="weight bands"
      icon={Weight}
      emptyDescription="Add the weight bands your loose-cargo rates are priced by."
      notice={<Alert type="info" showIcon title="These starter bands are placeholders until confirmed against Index Cargo's tariff." />}
      state={state}
      saveError={saveError}
      saving={saving}
      resetSaveError={resetSaveError}
      create={create}
      update={update}
      deactivate={deactivate}
      reactivate={reactivate}
      buildColumns={buildWeightBandColumns}
      Drawer={WeightBandFormDrawer}
    />
  );
}
